<template>
   <div class="add-block-wrapper">
      
      <div class="add-block-inner blue-bckgd">
         <div v-if="isLoadingData">
            <div class="loader-wrapper">
               <div class="loader">
               </div>
            </div>
         </div>
         <div v-else>
            <div class="block-subhead-wrapper">
               <slot name="header">
               </slot>
            </div>

            <div class="block-subhead-wrapper">
               <slot name="subheader">
               </slot>
            </div>

            <div class="block-container">
               <slot name="content">
               </slot>

               <slot name="schedule">
               </slot>
            </div>

            <block-action-bar
               :isEditing="isEditing"
               :isFeed="isFeed"
               :isSaving="isSaving"
               :isSavingAs="isSavingAs"
               :isDeleting="isDeleting"
               :isArchiving="isArchiving"
               :unsavedChanges="unsavedChanges"
               @saveClicked="$emit('saveClicked')"
               @saveAsDraftClicked="$emit('saveAsDraftClicked')"
               @saveAsClicked="$emit('saveAsClicked')"
               @resetClicked="$emit('resetClicked')"
               @cancelClicked="$emit('cancelClicked')"
               @deleteClicked="$emit('deleteClicked')"
               @archiveClicked="$emit('archiveClicked')">
            </block-action-bar>
         </div>
      </div>
   </div>
</template>

<script>
import BlockContent from './BlockContent';
import BlockActionBar from './BlockActionBar';

export default {
   props: {
      isEditing: {
         type: Boolean,
         required: false,
         default: false
      },
      isFeed: {
         type: Boolean,
         required: false,
         default: false
      },
      isSaving: {
         type: Boolean,
         required: false,
         default: false
      },
      isSavingAs: {
         typs: Boolean,
         required: false,
         default: false
      },
      isLoadingData: {
         type: Boolean,
         required: true
      },
      isDeleting: {
         type: Boolean,
         required: false,
         default: false
      },
      isArchiving: {
         type: Boolean,
         required: false,
         default: false
      },
      unsavedChanges: {
         type: Boolean,
         required: false,
         default: false
      }
   },

   components: {
      BlockContent,
      BlockActionBar
   }
}
</script>

<style lang="scss" scoped>
.add-block-wrapper {
   // min-width: 1400px;
   // position: absolute;
   border-left: 1px solid white;
   border-right: 1px solid white;
   border-bottom: 1px solid white;
   width: 100%;
   // right: 0;
}

.add-block-inner {
   padding: 30px 20px;
   min-height: 800px;
}

.block-subhead-wrapper {
   display: flex;
   margin-top: 7px;
   margin-bottom: 20px;
}

.block-container {
   min-height: 555px;
}

</style>